module.exports = __webpack_public_path__ + "img/jquery-icon.d37fec52.png";